export const isDownloadingSelector = (state) => state.downloads.isDownloading;
export const errorSelector = (state) => state.downloads.error;
export const csvSelector = (state) => state.downloads.csv;
